import ManageLoanOrigination from "../pages/workflow/loanOrigination/ManageLoanOrigination";
import NewLoanOrigination from "../pages/workflow/loanOrigination/NewLoanOrigination";

export default [
  {
    path: "/manage-loan-origination",
    component: ManageLoanOrigination,
    isProtected: true,
  },
  {
    path: "/new-loan-origination",
    component: NewLoanOrigination,
    isProtected: true,
  },
];
